import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from '../pages/login/Login';
import Home from '../pages/Prefeitura/Home/Home';
import CadastrarUsuario from '../pages/Adm/Cadastro/Usuario/CadastrarUsuario';
import CriarSolicitacao from '../pages/Prefeitura/CriarSolicitacao/CriarSolicitacao';
import HistoricoCompra from '../pages/Prefeitura/HistoricoCompra/HistoricoCompra';
import HomeADM from '../pages/Adm/Solicitacoes/SolicitacoesPrefeitura';
import LayoutADM from '../components/Layout/LayoutADM';
import LayoutPrefeitura from '../components/Layout/LayoutPrefeitura';
import LayoutFornecedor from '../components/Layout/LayoutFornecedor';
import ProtectedRoute from '../components/ProtectedRoute';
import SolicitarPrefeituraADM from '../pages/Adm/Solicitacoes/SolicitacoesPrefeitura';
import Cotacao from '../pages/Adm/Cotacao/Cotacao';
import AprovarCotacao from '../pages/Adm/Cotacao/AprovarCotacao';
import EditarSolicitacao from '../pages/Adm/Editar/EditarSolicitacao/EditarSolicitacao';
import CadastrarPrefeitura from '../pages/Adm/Cadastro/Prefeitura/CadastrarPrefeitura';
import CadastrarFornecedor from '../pages/Adm/Cadastro/Fornecedor/CadastrarFornecedor';
import CadastrarVeiculo from '../pages/Adm/Cadastro/Veiculo/CadastrarVeiculo';
import CadastrarContrato from '../pages/Adm/Cadastro/Contrato/CadastrarContrato';
import CadastrarSecretaria from '../pages/Adm/Cadastro/Secretaria/CadastrarSecretaria';
import GerenciarPrefeitura from '../pages/Adm/Gerenciar/Prefeitura/GerenciarPrefeitura';
import GerenciarFornecedor from '../pages/Adm/Gerenciar/Fornecedor/GerenciarFornecedor';
import EditarPrefeitura from '../pages/Adm/Editar/EditarPrefeitura/EditarPrefeitura';
import EditarFornecedor from '../pages/Adm/Editar/EditarFornecedor/EditarFornecedor';
import GerenciarUsuario from '../pages/Adm/Gerenciar/Usuario/GerenciarUsuario';
import EditarUsuario from '../pages/Adm/Editar/EditarUsuario/EditarUsuario';
import HomeFornecedor from '../pages/Fornecedor/Home/Home';
import InserirCotacao from '../pages/Fornecedor/InserirCotacao/InserirCotacao';
import HistoricoFor from '../pages/Fornecedor/Historico/HistoricoCompra';
import EditarSolicitacaoPRE from '../pages/Prefeitura/EditarSolicitacao/EditarSolicitacao';
import CotacoesEnviadas from '../pages/Fornecedor/CotacoesEnviadas/CotacoesEnviadas';
import RevisarCotacao from '../pages/Adm/RevisarCotacao/RevisarCotacao';
import Revisar from '../pages/Adm/RevisarCotacao/Revisar';
import HistoricoCompraADM from '../pages/Adm/HistoricoCompras/HistoricoCompraADM.js';
import RelatorioGeral from '../pages/Adm/Relatorio/RelatorioGeral';
import RelatorioFornecedor from '../pages/Adm/Relatorio/RelatorioFornecedor';
import RelatorioVendas from '../pages/Fornecedor/Relatorio/RelatorioVendas';
import RelatorioCompras from '../pages/Prefeitura/Relatorio/RelatorioCompras';


export default function AppRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />

        {/* ADM */}
        <Route path="/adm" element={
          <ProtectedRoute tipoPermitido="ADM">
            <LayoutADM />
          </ProtectedRoute>
        }>
          <Route path="dashboard" element={<HomeADM />} />
          <Route path="solicitacoes/:idPrefeitura" element={<SolicitarPrefeituraADM />} />
          <Route path= "RevisarCotacao" element={<RevisarCotacao />} />
          <Route path= "HistoricoCompraADM" element={<HistoricoCompraADM />} />
          
          <Route path="revisarcotacao/revisar" element={<Revisar />} />
          <Route path="cadastro">
            <Route path="usuario" element={<CadastrarUsuario />} />
            <Route path="prefeitura" element={<CadastrarPrefeitura />} />
            <Route path="fornecedor" element={<CadastrarFornecedor />} />
            <Route path="veiculo" element={<CadastrarVeiculo />} />
            <Route path="contrato" element={<CadastrarContrato />} />
            <Route path="secretaria" element={<CadastrarSecretaria />} />
          </Route>
          <Route path="gerenciar">
            <Route path="prefeitura" element={<GerenciarPrefeitura />} />
            <Route path="fornecedor" element={<GerenciarFornecedor />} />
           <Route path="usuario" element={<GerenciarUsuario/>} />
          </Route>
          <Route path="Relatorio">
            <Route path="relatorioGeral" element={<RelatorioGeral />} />
            <Route path="relatorioFornecedor" element={<RelatorioFornecedor />} />
          </Route>
          <Route path="cotacao/:idSolicitacao" element={<Cotacao />} />
          <Route path="cotacao/:idCotacao/aprovar" element={<AprovarCotacao />} />
          <Route path="editar-solicitacao" element={<EditarSolicitacao />} />
          <Route path="editar-prefeitura/:id" element={<EditarPrefeitura />} />
          <Route path= "editar-fornecedor/:id" element={<EditarFornecedor/>} />
         <Route path= "editar-usuario/:id" element={<EditarUsuario/>} />
          {/* Outras rotas ADM aqui */}
        </Route>

        {/* Prefeitura */}
        <Route path="/prefeitura" element={
          <ProtectedRoute tipoPermitido="PREFEITURA">
            <LayoutPrefeitura />
          </ProtectedRoute>
        }>
          <Route path="home" element={<Home />} />
          <Route path="CriarSolicitacao" element={<CriarSolicitacao />} />
          <Route path="HistoricoCompra" element={<HistoricoCompra />} />
          <Route path="editar-solicitacao" element={<EditarSolicitacaoPRE />} />
          <Route path="Relatorio" element={<RelatorioCompras />} />
          {/* Outras rotas Prefeitura aqui */}
        </Route>

        {/* Fornecedor */}
        <Route path="/fornecedor" element={
          <ProtectedRoute tipoPermitido="FORNECEDOR">
            <LayoutFornecedor />
          </ProtectedRoute>
        }>
          <Route path="home" element={<HomeFornecedor />} />
          <Route path="inserir-cotacao/:solicitacaoId" element={<InserirCotacao />} />
          <Route path="historicoCompra" element={<HistoricoFor/>}/>
          <Route path="cotacoesEnviadas" element={<CotacoesEnviadas/>}/>
          <Route path="relatorio" element={<RelatorioVendas/>}/>
          {/* Outras rotas Fornecedor aqui */}
        </Route>

        {/* Redirecionamento padrão */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  );
}
